<!-- Modal content-->
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'general.export' | translate}}</h4>
    <button type="button" title="close" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade" [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <p>{{'alert_history.export_inst' | translate}}</p>
    <form class="w-100" [formGroup]="exportHistoryForm" (ngSubmit)="exportData()" novalidate>
        <div class="row">
            <div class="col-6 mb-2">
                <label for="monthYear">{{'stat_report.month_year' | translate}}<span class="error">*</span></label><br>
                <div class="margin-less">
                    <mat-form-field class="full-width-datepicker">
                        <input id="monthYear" name="monthYear" matInput [matDatepicker]="dp" formControlName="monthYear" [formControl]="my" [min]="minDate" [max]="maxDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYear($event)" (monthSelected)="chosenMonth($event, dp)">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="exportHistoryForm.get('monthYear').invalid && (formSubmitted || exportHistoryForm.get('monthYear').touched || exportHistoryForm.get('monthYear').dirty)">
                    <div *ngIf="monthYear['errors']&&monthYear['errors']['required']" class="text-danger align-left">
                        {{'general.required_field' | translate}}
                    </div>
                </ng-container>
            </div>
            <div class="col-6 mb-2">
                <label for="alertTypeName">{{'alert.alert_type' | translate}}</label>
                <select id="alertTypeName" class="form-control" name="alertTypeName" formControlName="alertTypeName" [ngClass]="{ 'is-valid': alertTypeName['valid'], 'is-invalid': alertTypeName['invalid'] }" [(ngModel)]="defaultAlertType.name">
                    <option value="-" selected>{{'all' | translate}}</option>
                    <option *ngFor="let alertType of alertTypes">{{alertType.name}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-6 mb-2">
                <label for="status">{{'alert.closed_as' | translate}}</label>
                <select id="status" class="form-control" name="status" formControlName="status" [(ngModel)]="defaultStatus.id">
                    <option *ngFor="let typeOfAlert of realFalseArray" [value]="typeOfAlert.id">{{ typeOfAlert.status.toLowerCase() | translate }}</option>
                </select>
            </div>
            <div class="col-6 mb-2">
                <label for="canceled">{{'general.canceled_not' | translate}}</label><br>
                <!--<input type="checkbox" id="canceled" formControlName="canceled" />--->
                <select id="canceled" class="form-control" name="canceled" formControlName="canceled" [(ngModel)]="defaultCanceled.id">
                    <option *ngFor="let c of canceledArray" [value]="c.id">{{ c.status | translate }}</option>
                </select>
            </div>
            <div class="col-6 mb-2">
                <label for="late">{{'alert.late' | translate}}</label><br>
                <select id="late" class="form-control" name="late" formControlName="late" [(ngModel)]="defaultLate.id">
                    <option *ngFor="let l of lateArray" [value]="l.id">{{ l.status | translate }}</option>
                </select>
            </div>
            <div class="col-6 mb-2">
                <label for="groupName">{{'alert.groups' | translate}}</label><br>
                <select id="groupName" class="form-control" name="groupName" formControlName="groupName" [(ngModel)]="defaultGroup.name">
                    <option value="-" selected>{{'all' | translate}}</option>
                    <option *ngFor="let g of groups" [value]="g.name">{{ g.name | translate }}</option>
                </select>
            </div>
        </div>
        <hr class="hr-m">
        <div class="row">
            <div class="col-12 text-right">
                <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
                    {{'general.cancel' | translate}}
                </button>
                <button type="submit" title="{{'general.export' | translate}}" class="btn btn-green btn-h-green">
                    {{'general.export' | translate}}
                </button>
            </div>
        </div>
    </form>
</div>